export default {"src":"/_next/static/media/tv-minimal-play.0f672ea7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};